const types = {
  SET_CHALLENGES: 'SET_CHALLENGES',
  CLEAR_CHALLENGES: 'CLEAR_CHALLENGES',
  SET_TOTAL_CHALLENGES: 'SET_TOTAL_CHALLENGES',
  SET_CHALLENGE: 'SET_CHALLENGE',
  CLEAR_CHALLENGE: 'CLEAR_CHALLENGE',
  SET_REWARDS: 'SET_REWARDS',
  CLEAR_REWARDS: 'CLEAR_REWARDS',
  SET_CHALLENGE_REVS: 'SET_CHALLENGE_REVS',
  CLEAR_CHALLENGE_REVS: 'CLEAR_CHALLENGE_REVS',
  SET_CHALLENGE_LEADERBOARD_RANKING: 'SET_CHALLENGE_LEADERBOARD_RANKING',
  CLEAR_CHALLENGE_LEADERBOARD_RANKING: 'CLEAR_CHALLENGE_LEADERBOARD_RANKING',
  SET_CHALLENGE_TAGS_VISIBILITY: 'SET_CHALLENGE_TAGS_VISIBILITY',
  CLEAR_CHALLENGE_TAGS_VISIBILITY: 'CLEAR_CHALLENGE_TAGS_VISIBILITY',
  SET_REWARD: 'SET_REWARD',
  SET_CHALLENGE_FIELD: 'SET_CHALLENGE_FIELD',
  UPDATE_CHALLENGE_REWARD: 'UPDATE_CHALLENGE_REWARD',

  SET_CHALLENGE_MAINSTREAM_FILTER: 'SET_CHALLENGE_MAINSTREAM_FILTER',
  REMOVE_CHALLENGE_MAINSTREAM_FILTER: 'REMOVE_CHALLENGE_MAINSTREAM_FILTER',
  CLEAR_CHALLENGE_SITE: 'CLEAR_CHALLENGE_SITE',
  SET_CHALLENGE_SITE: 'SET_CHALLENGE_SITE',
  CLEAR_CHALLENGE_COLLABORATORS: 'CLEAR_CHALLENGE_COLLABORATORS',
  ADD_CHALLENGE_COLLABORATOR: 'SET_CHALLENGE_COLLABORATOR',
  REMOVE_CHALLENGE_COLLABORATOR: 'REMOVE_CHALLENGE_COLLABORATOR',
  CLEAR_CHALLENGE_SITE_ATTRIBUTES: 'CLEAR_CHALLENGE_SITE_ATTRIBUTES',
  ADD_CHALLENGE_SITE_ATTRIBUTES: 'ADD_CHALLENGE_SITE_ATTRIBUTES',
  REMOVE_CHALLENGE_SITE_ATTRIBUTES: 'REMOVE_CHALLENGE_SITE_ATTRIBUTES',
  SET_CHALLENGE_STREAM_QUERY: 'SET_CHALLENGE_STREAM_QUERY',
  CLEAR_CHALLENGE_STREAM_QUERY: 'CLEAR_CHALLENGE_STREAM_QUERY',
}

export default types
